/**
 * Created by Carsten Bühler
 * User: c.buehler on 23.08.2018
 * Copyright: xdot GmbH 2018
 */

const isFormValid = (formValidation) => {
    let formValid = true;
    if (formValidation) {
        Object.keys(formValidation).forEach(propName => {
            if (formValidation[ propName ]) {
                formValid = false;
            }
        });
    }
    return formValid;
};

export default {
    isFormValid
};



// WEBPACK FOOTER //
// ./js/utils/form-validation-util.js